import ProductSpecs from '@c/product-details/ProductSpecs';
import { ProductDocument, Variation } from 'models/product';

type ProductSpecsTabProps = {
  product: ProductDocument;
  selectedVariations: Variation[] | null;
};

export default function ProductSpecsTab({
  product,
  selectedVariations,
}: ProductSpecsTabProps) {
  return (
    <div className="flex flex-col gap-y-8 p-8">
      <ProductSpecs product={product} selectedVariations={selectedVariations} />
    </div>
  );
}
